import { useContext } from 'react';

import ContactContext from '../utils/context';

export default function useContactContext() {
  return useContext(ContactContext) ?? {};
}
